export const colorPalettes = {
  blue: {
    name: "blue",
    shades: [
      "#74c0fc", // 1 - lightest tint
      "#67b4ee", // 2
      "#469de0", // 3
      "#4191cd", // 4
      "#4dabf7", // 5
      "#339af0", // 6
      "#228be6", // 7
      "#1c7ed6", // 8
      "#1971c2", // 9
      "#1864ab", // 10 - darkest shade
    ],
    named: "blue",
  },
  yellow: {
    name: "yellow",
    shades: [
      "#ffd43b", // 1 - lightest tint
      "#fcc419", // 2
      "#fab005", // 3
      "#f59f00", // 4
      "#ffc947", // 5
      "#f08c00", // 6
      "#e67700", // 7
      "#d9480f", // 8
      "#c92a2a", // 9
      "#b0251f", // 10 - darkest shade
    ],
    named: "yellow",
  },
  red: {
    name: "red",
    shades: [
      "#ff8787", // 1 - lightest tint
      "#ff6b6b", // 2
      "#fa5252", // 3
      "#f03e3e", // 4
      "#ff8a95", // 5
      "#e03131", // 6
      "#c92a2a", // 7
      "#b02525", // 8
      "#9a1f1f", // 9
      "#861919", // 10 - darkest shade
    ],
    named: "red",
  },
  green: {
    name: "green",
    shades: [
      "#69db7c", // 1 - lightest tint
      "#51cf66", // 2
      "#40c057", // 3
      "#37b24d", // 4
      "#5dd87a", // 5
      "#2f9e44", // 6
      "#2b8a3e", // 7
      "#257030", // 8
      "#1f5f28", // 9
      "#1a4f21", // 10 - darkest shade
    ],
    named: "green",
  },
  purple: {
    name: "purple",
    shades: [
      "#b197fc", // 1 - lightest tint
      "#9775fa", // 2
      "#845ef7", // 3
      "#7950f2", // 4
      "#a68ff5", // 5
      "#6741d9", // 6
      "#5f3dc4", // 7
      "#5234a8", // 8
      "#452b8f", // 9
      "#3a2276", // 10 - darkest shade
    ],
    named: "purple",
  },
  orange: {
    name: "orange",
    shades: [
      "#ffc947", // 1 - lightest tint
      "#ffb84d", // 2
      "#ff922b", // 3
      "#fd7e14", // 4
      "#ffa94d", // 5
      "#f76707", // 6
      "#e8590c", // 7
      "#d9480f", // 8
      "#c2410c", // 9
      "#a63c0f", // 10 - darkest shade
    ],
    named: "orange",
  },
  teal: {
    name: "teal",
    shades: [
      "#66d9ef", // 1 - lightest tint
      "#3bc9db", // 2
      "#22b8cf", // 3
      "#15aabf", // 4
      "#5dd8e8", // 5
      "#0c8599", // 6
      "#0b7285", // 7
      "#0a6674", // 8
      "#095a63", // 9
      "#084d52", // 10 - darkest shade
    ],
    named: "teal",
  },
  pink: {
    name: "pink",
    shades: [
      "#f783ac", // 1 - lightest tint
      "#f06595", // 2
      "#e64980", // 3
      "#d63384", // 4
      "#ff9cc0", // 5
      "#c2255c", // 6
      "#ae1e5c", // 7
      "#9a1a4f", // 8
      "#861542", // 9
      "#721135", // 10 - darkest shade
    ],
    named: "pink",
  },
  indigo: {
    name: "indigo",
    shades: [
      "#8b9aff", // 1 - lightest tint
      "#7480ff", // 2
      "#5c7cfa", // 3
      "#4c6ef5", // 4
      "#9ca8ff", // 5
      "#364fc7", // 6
      "#2f3e8f", // 7
      "#293577", // 8
      "#232c5f", // 9
      "#1d2347", // 10 - darkest shade
    ],
    named: "indigo",
  },
  emerald: {
    name: "emerald",
    shades: [
      "#6ee7b7", // 1 - lightest tint
      "#4ade80", // 2
      "#34d399", // 3
      "#2dd4bf", // 4
      "#7ef0c8", // 5
      "#10b981", // 6
      "#059669", // 7
      "#047857", // 8
      "#036548", // 9
      "#025238", // 10 - darkest shade
    ],
    named: "emerald",
  },
  amber: {
    name: "amber",
    shades: [
      "#fcd34d", // 1 - lightest tint
      "#fbbf24", // 2
      "#f59e0b", // 3
      "#d97706", // 4
      "#fdd663", // 5
      "#b45309", // 6
      "#92400e", // 7
      "#78350f", // 8
      "#5e2d0c", // 9
      "#442509", // 10 - darkest shade
    ],
    named: "amber",
  },
  violet: {
    name: "violet",
    shades: [
      "#9d6dd9", // 1 - lightest tint (darker)
      "#8b5dd1", // 2 (darker)
      "#7a4dc9", // 3 (darker)
      "#6d3db8", // 4 (darker)
      "#a67de8", // 5 (darker)
      "#7c3aed", // 6
      "#6d28d9", // 7
      "#5b21b6", // 8
      "#3d1a6b", // 9
      "#1e0a3d", // 10 - darkest shade
    ],
    named: "violet",
  },
  turquoise: {
    name: "turquoise",
    shades: [
      "#7dd3fc", // 1 - lightest tint
      "#38bdf8", // 2
      "#0ea5e9", // 3
      "#0284c7", // 4
      "#93c5fd", // 5
      "#0369a1", // 6
      "#075985", // 7
      "#0c4a6e", // 8
      "#0f3a58", // 9
      "#122a42", // 10 - darkest shade
    ],
    named: "turquoise",
  },
  gray: {
    name: "gray",
    shades: [
      "#b8bcc4", // 1 - lightest tint
      "#8a909f", // 2
      "#6b7280", // 3
      "#787f88", // 4
      "#868e96", // 5
      "#495057", // 6
      "#343a40", // 7
      "#2c3136", // 8
      "#25292d", // 9
      "#212529", // 10 - darkest shade
    ],
    named: "gray",
  },
};
